import { FaCreditCard } from "react-icons/fa";
import { defineField, defineType } from "sanity";

export default defineType({
  name: "ecommerceRoyalOne",
  title: "Royal ONE",
  type: "document",
  icon: FaCreditCard,
  fields: [
    defineField({
      name: "royalOnePaymentBannerImage",
      title: "Royal ONE Payment Step Banner Image",
      type: "image",
      options: { hotspot: true },
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "royalOnePaymentBannerLink",
      title: "Royal ONE Payment Step Banner Link",
      type: "multilingualUrl",
      validation: (Rule) => Rule.required()
    })
  ],
  preview: {
    prepare(value) {
      return {
        title: "Royal ONE"
      };
    }
  }
});
